// extracted by mini-css-extract-plugin
export default {"heroContainer":"HeroSection_heroContainer__gpAVs","sliderTrack":"HeroSection_sliderTrack__WLjjD","heroImage":"HeroSection_heroImage__RejFk"};